import { categories } from "@/mocks/categories";

export const getCategoryName = (id: string) =>
  categories.find((c) => c.id === id)?.name ?? "热点";

export const getCategoryIcon = (id: string) =>
  categories.find((c) => c.id === id)?.icon ?? "ri-fire-line";

export const formatViews = (views: number) =>
  views >= 10000 ? `${(views / 10000).toFixed(1)} 万` : `${views}`;